module.exports = __webpack_public_path__ + "real_icon.svg?f8e7bc1f1872012b834b8da38e105f59";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/real_icon.svg
// module id = 1118
// module chunks = 2